/* eslint-disable */

import React from "react";
import clsx from "clsx";
import { StandardProps } from "../common";

import "./Button.scss";

export type ButtonSize = "small" | "medium" | "large";

export type ButtonVariant = "primary" | "secondary" | "text";

export interface ButtonProps extends StandardProps {
  size?: ButtonSize;
  variant?: ButtonVariant;
  startIcon?: any;
  endIcon?: any;
  children?: React.ReactNode;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
  disabled?: boolean;
}

const Button = ({
  size = "large",
  variant = "primary",
  startIcon,
  endIcon,
  children,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={clsx([
        "button",
        size,
        variant,
        startIcon && "icon-start",
        endIcon && "icon-end",
      ])}
      {...props}
    >
      {startIcon}
      {children}
      {endIcon}
    </button>
  );
};

export default Button;
